const initState = () => {
  return {
    index: "1",
    resumeReminder: [], // talent
    jobReminder: [],
  };
};

const app = (state = initState(), action) => {
  switch (action.type) {
    case "SET_INDEX":
      return { ...state, ...{ index: action.payload } };

    case "SET_RESUME_REMINDER":
      return { ...state, ...{ resumeReminder: action.payload } };

    case "SET_JOB_REMINDER":
      return { ...state, ...{ jobReminder: action.payload } };

    default:
      return state;
  }
};

export default app;
